import { watch, computed } from "vue";
import { useRoute } from "vue-router";

export function useTitle(defaultTitle) {
    const route = useRoute();

    // Создаем реактивный заголовок с добавлением текста
    const pageTitle = computed(() => {
        return defaultTitle ? `${defaultTitle}` : route.meta.title;
    });

    watch(
        pageTitle,
        (newTitle) => {
            document.title = newTitle;
        },
        { immediate: true }
    );
}

export const getCleanTitle = (route) => {
    const fullTitle = route.meta?.title || 'Личный кабинет';
    return fullTitle.replace(' - Буйян', '');
};

export const setDocumentTitle = (route) => {
    document.title = route.meta?.title || 'Буйян';
};
